import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { AuthProvider } from './context/AuthContext'; // ✅ ADD THIS

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <AuthProvider>   {/* ✅ WRAP APP */}
      <App />
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();